import {hasParentEntity} from "./TreeViewForListView";
import {TreeModelProvider} from "./TreeModelProvider";
import * as ClientCache from "../../login/ClientCache";
import * as TreeViewForListView from "../treeView/TreeViewForListView";

export class TreeViewForEditView {
    constructor(entityType) {
        this.entityType = entityType;
    }

    getHelperForEditView() {
        let entityType = this.entityType;
        if (hasParentEntity(entityType))
            return TreeViewForListView.PARENT_FILTER_HELPER;
        if (ClientCache.isMasterFile(entityType))
            return TreeViewForListView.GROUP_FILTER_HELPER;
        return null;
    }

    getTreeModelProviderForEditView() {
        let entityType = this.entityType;
        if (!hasParentEntity(entityType))
            return null;
        return new TreeModelProvider(entityType);

    }
}